import { render, staticRenderFns } from "./distributorShowRule.vue?vue&type=template&id=587e1128&scoped=true"
import script from "./distributorShowRule.vue?vue&type=script&lang=js"
export * from "./distributorShowRule.vue?vue&type=script&lang=js"
import style0 from "./distributorShowRule.vue?vue&type=style&index=0&id=587e1128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e1128",
  null
  
)

export default component.exports